import { Box, TextButton, } from '@wix/design-system';
import { ChevronDown } from '@wix/wix-ui-icons-common/lazy';
import classNames from 'classnames';
import React from 'react';
import s from './Collapse.scss';
export const ToggleCollapsibleButton = ({ isOpen, labels, collapsible = true, dataHook, visible, skin = 'standard', size, classNames: styling, icon, iconColor, iconSize = 30, onToggle, }) => {
    const handleClick = () => {
        onToggle?.(isOpen ? 'close' : 'open');
    };
    return (React.createElement("div", { onClick: handleClick },
        React.createElement(Box, { className: classNames(s.toggleButton, styling?.container), dataHook: dataHook, gap: "SP2" }, collapsible && (React.createElement(React.Fragment, null,
            React.createElement(Box, { className: classNames(s.toggleButtonText, {
                    [s.visible]: visible,
                }), verticalAlign: "middle" },
                React.createElement(TextButton, { size: size, skin: skin, className: styling?.label }, isOpen ? labels?.close : labels?.open)),
            React.createElement(Box, { className: classNames(s.toggleButtonIconContainer, styling?.icon), align: "center", verticalAlign: "middle" }, icon ?? (React.createElement(ChevronDown, { size: iconSize, color: iconColor, className: classNames(s.toggleButtonIcon, {
                    [s.open]: isOpen,
                }) }))))))));
};
//# sourceMappingURL=ToggleCollapsibleButton.js.map